@use "Styles/includes/variables";
@use "Styles/mixins";

$avatar-size: 40px;

:host {
    display: block;
    width: 100%;
}

.comment {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    list-style-type: none;
    font-family: variables.$fontQuaternary;

    &__inner-wrap {
        width: 100%;
        display: flex;
        align-items: flex-start;
    }

    &__profile-image {
        flex-shrink: 0;

        vm-profile-image {
            display: block;
            width: $avatar-size;
            height: $avatar-size;

            &::part(link) {
                display: block;
                text-decoration: none;
            }

            &::part(image) {
                object-fit: cover;
            }

            &::part(initials) {
                font-size: mixins.get-font-size(text-md);
                line-height: mixins.get-line-height(text-md);
                font-weight: 600;
            }
        }
    }

    &__content-wrap {
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        // Flex default is `min-width: auto`; explicitly 0 so a long
        // unbreakable token can't blow past the row width.
        min-width: 0;
        gap: 8px;
    }

    &__text {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 0 0 0 16px;
    }

    &__header {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    &__author {
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        font-weight: 700;
        color: mixins.get-color(text, text-primary);
        text-decoration: none;
    }

    &__timestamp {
        font-size: mixins.get-font-size(text-xs);
        line-height: mixins.get-line-height(text-xs);
        font-weight: 500;
        color: mixins.get-color(text, text-quaternary);
    }

    &__body {
        margin: 0;
        overflow-wrap: anywhere;
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        font-weight: 500;
        color: mixins.get-color(text, text-tertiary);
    }

    &__attachments-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        vm-image-thumbnail {
            --vm-image-thumbnail-size: 63px;
            --vm-image-thumbnail-radius: 8px;
        }
    }

    &__footer {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        padding: 0 0 0 4px;
    }

    &__replies-list {
        box-sizing: border-box;
        width: 100%;
        padding: 0 0 0 56px;
        margin: 0;
        list-style-type: none;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    // Desktop-only
    &__inline-composer {
        margin: 12px 0 0 16px;
    }

    &--reply {
        // Flatten nested replies — same single-level indent at every depth.
        .comment__replies-list {
            padding: 0;
        }

        .comment__inline-composer {
            // Cancels the avatar column so the reply composer left-aligns with the
            // parent comment's body — depends on `.comment__replies-list` having
            // `padding-left: $avatar-size + 16px` above. Keep the two in sync.
            margin-left: -$avatar-size;
        }
    }
}
